import InvalidPriceError from './InvalidPriceError.js'
import InvalidTaxError from './InvalidTaxError.js'

export default class PaymentErrorsFactory {
  static invalidPriceError = () => new InvalidPriceError()

  static invalidTaxError = () => new InvalidTaxError()
}
